import React, {Component} from 'react';
import Select from "react-select";

class CreateOrderHostingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOs: false,
            isAddon: false,
            isChosseProduct: false,
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.props.changeInput(name, value);
    }

    render() {
        return (
            <>
                {/*Sản phẩm*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Sản phẩm</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listProduct}
                            onChange={ this.props.choosseProduct() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn sản phẩm'}
                        />
                    </div>
                </div>
                {/*Domain*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Domain</div>
                    <div className="col-md-8">
                        <input type="text" className="form-control" name="domain" onChange={ this.changeInput } value={ this.props.domain } />
                    </div>
                </div>
                {/*Thời gian thuê*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Thời gian thuê</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listBillingCycle}
                            onChange={ this.props.choosseBillingCycle() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn thời gian thuê'}
                        />
                    </div>
                </div>
                {/*  Trừ tiền tài khoản  */}
                {
                    this.props.status === 'Finish' ? (
                        <div className="row form-group mt-4">
                            <div className="col-md-3 text-right font-weight-bold">Trừ tiền tài khoản</div>
                            <div className="col-md-8">
                                <input type="checkbox" name="minusCredit" onChange={ this.changeInput } value={ this.props.minusCredit } />
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }
}

export default CreateOrderHostingComponent;